import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'haybale',
      d: 'M-2,-2.5h1.5v0.5h-1.5zM-2.5,-2h2.5v0.5h-2.5zM1.5,-2h1v0.5h-1zM-2.5,-1.5h5v1.5h-5zM-2,0h4v0.5h-4z',
    },
    { paint: 'wheat', d: 'M-0.5,-2.5h2v0.5h-2zM0,-2h1.5v0.5h-1.5z' },
  ],
  pixels: 55,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
